import React from 'react';
import { Play } from 'lucide-react';
import { videoEmbedUrl, videoPoster } from '../mock';

export default function VideoSection() {
  return (
    <section className="section" style={{ backgroundColor: 'var(--cream)' }} data-testid="video-section">
      <div className="container-x">
        <div className="text-center max-w-[820px] mx-auto reveal">
          <p className="eyebrow mb-2">Watch Our Story</p>
          <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
            It only takes one call to deliver the peace of mind you&rsquo;ve been longing for.
          </h2>
        </div>

        <div className="mt-12 max-w-[960px] mx-auto reveal">
          <div
            className="relative rounded-[28px] overflow-hidden"
            style={{ aspectRatio: '16 / 9', boxShadow: '0 30px 60px -30px rgba(30,59,44,0.55)' }}
          >
            {videoEmbedUrl ? (
              <iframe
                src={videoEmbedUrl}
                title="Mom's Best Friend Senior Care Promo"
                className="absolute inset-0 w-full h-full"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                data-testid="promo-video-iframe"
              />
            ) : (
              <div className="absolute inset-0" data-testid="promo-video-placeholder">
                <img src={videoPoster} alt="Caring for seniors at home in Dallas–Fort Worth" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(20,42,31,0.25) 0%, rgba(20,42,31,0.6) 100%)' }} />
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
                  <span
                    className="flex items-center justify-center rounded-full transition-transform duration-300 hover:scale-110"
                    style={{ width: 84, height: 84, backgroundColor: 'var(--service-yellow)', boxShadow: '0 12px 30px -8px rgba(0,0,0,0.4)' }}
                  >
                    <Play size={34} style={{ color: 'var(--forest)', marginLeft: 4 }} fill="var(--forest)" />
                  </span>
                  <span className="text-white/85 text-sm tracking-wide">Promo video coming soon</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
